import { useTranslation } from 'react-i18next';

import type { FilterConfig } from './types';

import { getAppliedValue, getValueTexts, hasValue } from './utils';

export const useListFiltersSummary = (filters: FilterConfig[]) => {
  const { t } = useTranslation();
  const booleanLabels = { yes: t('Yes'), no: t('No') };

  const activeChips = filters.flatMap((filter) =>
    getValueTexts(filter, booleanLabels).map((text, index) => ({
      key: `${filter.name}-${index}`,
      text: `${filter.label}: ${text}`,
    })),
  );
  const activeFiltersCount = filters.filter((filter) =>
    hasValue(getAppliedValue(filter)),
  ).length;
  const clearableFilters = filters.filter(
    ({ value, hideClearButton }) => hasValue(value) && !hideClearButton,
  );

  const onAllFiltersClear = () => {
    clearableFilters.forEach(({ onClear }) => onClear());
  };

  return {
    activeChips,
    activeFiltersCount,
    isClearable: clearableFilters.length > 0,
    onAllFiltersClear,
  };
};
